import { render, staticRenderFns } from "./ClienteEdit.vue?vue&type=template&id=0a7da92d"
import script from "./ClienteEdit.vue?vue&type=script&lang=js"
export * from "./ClienteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports